import { defineMessages } from "react-intl";

export const messages = defineMessages({
  "team.heading": {
    id: "team.heading",
    defaultMessage: "Team",
  },
  "team.members.title": {
    id: "team.members.title",
    defaultMessage: "Members",
  },
  "team.members.title.count.badge": {
    id: "team.members.title.count.badge",
    defaultMessage: `{count, plural, =0 {No Members} =1 {# Member} other {# Members} }`,
  },
  "team.members.sub": {
    id: "team.members.sub",
    defaultMessage: "If you manage more members, they are listed below.",
  },
  "team.members.add": {
    id: "team.members.add",
    defaultMessage: "Add member",
  },
  "team.members.table.col.name": {
    id: "team.members.table.col.name",
    defaultMessage: "Name",
  },
  "team.members.table.col.coach": {
    id: "team.members.table.col.coach",
    defaultMessage: "Coach",
  },
  "team.members.table.col.paid": {
    id: "team.members.table.col.paid",
    defaultMessage: "Credits paid",
  },
  "team.members.table.col.remaining": {
    id: "team.members.table.col.remaining",
    defaultMessage: "Remaining credits",
  },
  "team.members.table.col.requested": {
    id: "team.members.table.col.requested",
    defaultMessage: "Requested credits",
  },
  "team.members.table.col.scheduled": {
    id: "team.members.table.col.scheduled",
    defaultMessage: "Scheduled credits",
  },
  "team.members.table.col.longTermGoal": {
    id: "team.members.table.col.longTermGoal",
    defaultMessage: "Long-term goals",
  },
  "team.members.table.col.areaOfDevelopment": {
    id: "team.members.table.col.areaOfDevelopment",
    defaultMessage: "Area of Development",
  },
  "team.members.table.col.strengths": {
    id: "team.members.table.col.strengths",
    defaultMessage: "Top5 talents",
  },
  // "team.members.table.col.all": {
  //   id: "team.members.table.col.all",
  //   defaultMessage: "All credits",
  // },
  "team.members.table.col.action": {
    id: "team.members.table.col.action",
    defaultMessage: "Action",
  },
  "team.credit.topup": {
    id: "team.credit.topup",
    defaultMessage: "Top up credit",
  },
  "team.credit.topup-modal.title": {
    id: "team.credit.topup-modal.title",
    defaultMessage: "Credit top up",
  },
  "team.credit.topup-modal.desc": {
    id: "team.credit.topup-modal.desc",
    defaultMessage: "Enter the amount of credits you want to top up.",
  },
  "team.credit.topup-modal.amount.label": {
    id: "team.credit.topup-modal.amount.label",
    defaultMessage: "Amount of credits (1 credit = 1$)",
  },
  "team.credit.topup-modal.submit": {
    id: "team.credit.topup-modal.submit",
    defaultMessage: "Request credit top up",
  },
  "team.credit.add-member.submit": {
    id: "team.credit.add-member.submit",
    defaultMessage: "Send invite",
  },
  "team.credit.edit-member.submit": {
    id: "team.credit.edit-member.submit",
    defaultMessage: "Save",
  },
  "team.credit.add-member.modal.title": {
    id: "team.credit.add-member.modal.title",
    defaultMessage: "Add new member",
  },
  "team.credit.edit-member.modal.title": {
    id: "team.credit.edit-member.modal.title",
    defaultMessage: "Edit member",
  },
  "team.credit.add-member.modal.desc": {
    id: "team.credit.add-member.modal.desc",
    defaultMessage:
      "To add a new member, enter the required information below.",
  },

  "team.credit.add-member.fields.firstName": {
    id: "team.credit.add-member.fields.firstName",
    defaultMessage: "Name",
  },
  "team.credit.add-member.fields.lastName": {
    id: "team.credit.add-member.fields.lastName",
    defaultMessage: "Surname",
  },
  "team.credit.add-member.fields.username": {
    id: "team.credit.add-member.fields.username",
    defaultMessage: "Email",
  },
  "team.credit.add-member.fields.authorities": {
    id: "team.credit.add-member.fields.authorities",
    defaultMessage: "Authorities",
  },
  "team.credit.add-member.fields.isManager": {
    id: "team.credit.add-member.fields.isManager",
    defaultMessage: "Is manager",
  },
  "team.credit.add-member.fields.manager": {
    id: "team.credit.add-member.fields.manager",
    defaultMessage: "Manager",
  },
  "team.credit.add-member.fields.position": {
    id: "team.credit.add-member.fields.position",
    defaultMessage: "Position",
  },
  "team.credit.add-member.fields.aspiredCompetency": {
    id: "team.credit.add-member.fields.aspiredCompetency",
    defaultMessage: "Aspired competency",
  },
  "team.credit.add-member.fields.locale": {
    id: "team.credit.add-member.fields.locale",
    defaultMessage: "Select languages",
  },
  "team.credit.add-member.fields.timeZone": {
    id: "team.credit.add-member.fields.timeZone",
    defaultMessage: "Timezone",
  },

  "team.credit.add-member.fields.trial-user": {
    id: "team.credit.add-member.fields.trial-user",
    defaultMessage: "Trial user",
  },
});
